import {FieldDefinition} from "./field-definition";
import {TableModel} from "../table/table-model";
import {RelationshipModel} from "../relationship/relationship-model";

export class FieldModel {

  private readonly definition: FieldDefinition;
  private readonly parent: TableModel;

  constructor(definition: FieldDefinition, parent: TableModel) {
    this.definition = definition;
    this.parent = parent;
  }

  getTableName(): string {
    return this.parent?.getTableName();
  }

  getTableModel(): TableModel {
    return this.parent;
  }

  getID() {
    return this.getDefaultedField("_id");
  }

  getName() {
    return this.getDefaultedField("_fieldName");
  }

  getParentTableName() {
    return this.getDefaultedField("_parentTable");
  }

  getFieldType() {
    return this.getDefaultedField("_fieldType");
  }

  getLength() {
    return this.getDefaultedField("_length");
  }

  isInherited() {
    return this.getDefaultedField("_inherited", false);
  }

  isUnique() {
    return this.getDefaultedField("_unique", false);
  }

  getProperty(propertyName: string) {
    return this.getDefaultedField("_properties", {})[propertyName];
  }

  getI18nKey() {
    return this.getDefaultedField("_i18nKey");
  }

  getPrefixIcon() {
    return this.getDefaultedField("_prefixIcon");
  }

  getPlaceHolderI18nKey() {
    return this.getDefaultedField("_placeholderI18nKey");
  }

  isRequired() {
    return this.getDefaultedField("_required", false);
  }

  isDisplayField() {
    return this.getDefaultedField("_displayField", false);
  }

  isReadOnly() {
    return this.getDefaultedField("_readOnly", false);
  }

  getRenderer() {
    return this.getDefaultedField("_renderer");
  }

  getRendererProperties() {
    return this.getDefaultedField("_rendererProperties", {});
  }

  getQueryRenderer() {
    return this.getDefaultedField("_queryRenderer");
  }

  getQueryRendererProperties() {
    return this.getDefaultedField("_queryRendererProperties", {});
  }

  isRelationType() {
    return Object.values(RelationshipModel.FIELD_TYPES).includes(this.getFieldType().toLowerCase());
  }

  getFieldDefinition(): FieldDefinition {
    return this.definition;
  }

  private getDefaultedField(property: any, defaultValue?: any) {
    const value = this.definition[property];
    return value !== null && value !== undefined ? value : defaultValue;
  }

  static create(definition: FieldDefinition, parent: TableModel): FieldModel {
    return new FieldModel(definition, parent);
  }

}
